"use client";

import { useState, type SVGProps } from "react";
import {
	Instagram,
	MessageSquareText,
	X,
} from "lucide-react";

function WhatsAppIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M12.04 2a9.84 9.84 0 0 0-8.42 14.93L2 22l5.2-1.58A9.97 9.97 0 1 0 12.04 2Zm0 17.98a8.15 8.15 0 0 1-4.15-1.14l-.3-.18-3.08.94 1-3-.2-.31a8.14 8.14 0 1 1 6.73 3.69Zm4.47-6.1c-.24-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.54.12-.16.25-.62.8-.76.97-.14.16-.28.18-.52.06-.25-.12-1.03-.38-1.97-1.21a7.34 7.34 0 0 1-1.36-1.69c-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.47-.4-.4-.54-.41h-.46c-.16 0-.42.06-.64.3-.22.25-.84.83-.84 2.02s.86 2.34.98 2.5c.12.16 1.7 2.6 4.12 3.65.58.25 1.03.4 1.38.51.58.18 1.1.16 1.52.1.46-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28Z" />
		</svg>
	);
}

function MessengerIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M12 2C6.48 2 2 6.15 2 11.27c0 2.91 1.42 5.51 3.64 7.23V22l3.33-1.82c.96.27 1.98.41 3.03.41 5.52 0 10-4.15 10-9.32C22 6.15 17.52 2 12 2Zm1 12.5-2.55-2.72-4.97 2.72 5.47-5.81 2.6 2.72 4.92-2.72L13 14.5Z" />
		</svg>
	);
}

const channels = [
	{
		label: "WhatsApp",
		href: "https://wa.me/61469071101",
		color: "#25d366",
		icon: WhatsAppIcon,
	},
	{
		label: "Messenger",
		href: "https://m.me/PteUltra",
		color: "#08a8f0",
		icon: MessengerIcon,
	},
	{
		label: "Instagram",
		href: "https://www.instagram.com/pteultra.ai/",
		color:
			"linear-gradient(135deg, #ffdf00 0%, #ff2d55 48%, #d300c5 78%, #7638fa 100%)",
		icon: Instagram,
	},
] as const;

export default function ChatWithUsLauncher() {
	const [expanded, setExpanded] = useState(false);

	return (
		<>
			<div className="chat-with-us-launcher fixed bottom-5 right-4 z-[10000] flex flex-col items-center gap-3 sm:bottom-6 sm:right-6">
				{expanded ? (
					<div
						id="chat-with-us-options"
						className="flex flex-col items-center gap-3"
					>
						{channels.map(({ label, href, color, icon: Icon }) => (
							<a
								key={label}
								href={href}
								target="_blank"
								rel="noreferrer noopener"
								aria-label={`Chat with us on ${label}`}
								title={label}
								className="grid h-14 w-14 place-items-center rounded-full text-white shadow-lg transition-transform hover:-translate-y-0.5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current sm:h-16 sm:w-16"
								style={{ background: color }}
							>
								<Icon aria-hidden="true" width={29} height={29} strokeWidth={2.25} />
							</a>
						))}
					</div>
				) : null}

				<button
					type="button"
					onClick={() => setExpanded((value) => !value)}
					aria-label={expanded ? "Close chat options" : "Chat with Us"}
					aria-expanded={expanded}
					aria-controls="chat-with-us-options"
					title={expanded ? "Close" : "Chat with Us"}
					className="grid h-14 w-14 place-items-center rounded-full bg-[#08cfe0] text-white shadow-xl transition-transform hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#08cfe0] sm:h-16 sm:w-16"
				>
					{expanded ? (
						<X aria-hidden="true" size={34} strokeWidth={2.2} />
					) : (
						<MessageSquareText aria-hidden="true" size={30} strokeWidth={2.2} />
					)}
				</button>
			</div>
		</>
	);
}
